<template>
  <div class="section-heading container">
    <h2 class="heading-2">
      <slot name="heading-title"></slot>
    </h2>
    <h1 class="heading-1" v-if="logo">RIZES House</h1>
    <p class="description">
      <slot name="heading-description"></slot>
    </p>
  </div>
</template>

<script>
export default {
  name: 'HeadingSection',
  props: {
    logo: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.section-heading {
  width: 98%;
  max-width: 11280px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 14px 0;

  .description {
    width: 60%;
    color: hsl(var(--clr-primary-100));
    // color: var(--primary);
  }
}

.heading-1 {
  font-family: var(--ff-cursive);
  font-size: 36px;
  letter-spacing: 1.5px;
  font-weight: 700;
  color: hsl(var(--clr-primary-100));
  padding: 16px 0;
  // margin-bottom: 16px;
  border-bottom: hsl(var(--clr-accent-500));
}

.heading-2 {
  font-family: var(--ff-serif);
  font-weight: 400;
  font-size: 20px;
  letter-spacing: 1px;
  color: hsl(var(--clr-primary-100));
  text-transform: uppercase;
  // margin-bottom: 14px;

  &--dark {
    color: hsl(var(--clr-primary-700));
  }

  &--light {
    color: hsl(var(--clr-primary-100));
  }
}

@media (max-width: 900px) {
  .section-heading {
    .description {
      width: 80%;
    }
  }
}
</style>
